import React, { createContext, useContext, useState, useEffect } from 'react';
import { imageService } from '../services/imageService';

const SiteImagesContext = createContext({});

export function SiteImagesProvider({ children }) {
  const [images, setImages] = useState({});
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    imageService.getAll().then(data => {
      const map = {};
      data.forEach(img => { map[img.image_key] = img.image_url; });
      setImages(map);
      setLoaded(true);
    }).catch(() => setLoaded(true));
  }, []);

  const getImage = (key, fallback) => images[key] || fallback;

  return (
    <SiteImagesContext.Provider value={{ images, getImage, loaded }}>
      {children}
    </SiteImagesContext.Provider>
  );
}

export function useSiteImages() {
  return useContext(SiteImagesContext);
}